import { render } from "./LanguagesView.vue?vue&type=template&id=44be5ec4&scoped=true"
import script from "./LanguagesView.vue?vue&type=script&scoped=true&lang=js"
export * from "./LanguagesView.vue?vue&type=script&scoped=true&lang=js"

import "./LanguagesView.vue?vue&type=style&index=0&id=44be5ec4&scoped=true&lang=css"

import exportComponent from "C:\\source\\LETC\\CorpWebsite\\LETC_vr_Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44be5ec4"]])

export default __exports__